// extracted by mini-css-extract-plugin
export default {"page":"kY-z","cartModal":"lY-z","checkout":"mY-z","placeholder":"nY-z","account":"oY-z"};